export default "__VITE_ASSET__C068olBu__"